export function isPureObject(item: unknown): boolean {
  return !!item && item?.constructor.name === "Object"
}
